import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import { Ornament } from "@/components/SectionTitle";
import { StatusBadge } from "@/components/StatusBadge";
import { PROJECTS, projectPath } from "@/data/site";

const ferry = PROJECTS.find((p) => p.slug === "ferry-service");

export const FerryShowcase = () => (
  <section className="relative bg-ivory-muted lg:py-24" data-testid="home-ferry-showcase">
    <div className="mx-auto max-w-[1440px] lg:px-10">
      <div className="relative">
        <FadeUp className="lg:w-[72%]">
          <img src={ferry.image.src} alt="The estate's passenger ferry crossing turquoise water beneath forested hills" loading="lazy" className="aspect-[4/3] w-full object-cover lg:aspect-[3/2]" />
        </FadeUp>
        <FadeUp delay={0.15} className="relative mx-5 -mt-16 border border-gold/50 bg-ivory p-8 shadow-[0_30px_80px_-40px_rgba(14,38,31,0.6)] md:mx-10 md:p-12 lg:absolute lg:right-0 lg:top-1/2 lg:mx-0 lg:mt-0 lg:w-[44%] lg:-translate-y-1/2">
          <Ornament />
          <p className="mt-3 font-caps text-[12px] tracking-[0.32em] uppercase text-gold-deep">Arrive by Sea</p>
          <h2 className="mt-4 font-caps text-3xl leading-tight text-heritage md:text-[2.6rem]">The Estate Ferry</h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-ink">
            A passenger ferry connecting Pigeon Point with Little Englishman's Bay, designed and now being built. Picture leaving the island's most famous beach behind and following Tobago's forested coastline to the estate by sea.
          </p>
          <div className="mt-6"><StatusBadge status={ferry.status} testid="ferry-showcase-status" /></div>
          <Link to={projectPath(ferry)} data-testid="ferry-showcase-button" className="group mt-8 inline-flex items-center gap-3 border border-gold-deep bg-gold-deep px-7 py-4 font-caps text-[12px] tracking-[0.24em] uppercase text-ivory transition-colors duration-500 hover:border-heritage hover:bg-heritage">
            Discover the Ferry <ArrowRight size={15} className="transition-transform duration-500 group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </div>
    </div>
    <div className="h-16 lg:hidden" />
  </section>
);
